module.exports = __webpack_public_path__ + "img/continue.15ded78b.png";